import { useCustomSaveProposalWorksheetItemAsProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useSaveProposalWorksheetItemAsProduct() {
  const [mutation, { loading, data, error }] = useCustomSaveProposalWorksheetItemAsProductMutation({
    refetchQueries: ["customGetWorksheetProducts"],
  });
  const [saveProposalWorksheetItemAsProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "saveProposalWorksheetItemAsProduct",
    },
    {
      successMessage: getLocalString("worksheet.save-item-as-product-success"),
      failureMessage: getLocalString("worksheet.save-item-as-product-failure"),
      showValidationErrors: true,
    }
  );

  return [saveProposalWorksheetItemAsProduct, context] as const;
}
